import { gql } from "graphql-tag";
import { POSITION_FRAGMENT } from "./progress";
export const BOOKMARK_DEEP_FRAGMENT = `
  fragment BookmarkDeepFragment on Bookmark {
    id
    position {
      ...PositionFragment
    }
    percentage
    contentId
    duration
    createdAt
    updatedAt
    note
  }
  ${POSITION_FRAGMENT}
`;
export const BOOKMARK_SHALLOW_FRAGMENT = `
  fragment BookmarkShallowFragment on Bookmark {
    id
    contentId
  }
`;
export const BOOKMARK_GET = gql `
  query allBookmarks($contentId: ID!) {
    bookmarks: allBookmarks(contentId: $contentId) {
      ...BookmarkDeepFragment
    }
  }
  ${BOOKMARK_DEEP_FRAGMENT}
`;
export const BOOKMARK_UPSERT = gql `
  mutation upsertBookmark($item: UpsertBookmarkDto!) {
    result: upsertBookmark(item: $item) {
      ...BookmarkDeepFragment
    }
  }
  ${BOOKMARK_DEEP_FRAGMENT}
`;
export const BOOKMARK_DELETE = gql `
  mutation deleteBookmark($item: DeleteBookmarkDto!) {
    result: deleteBookmark(item: $item) {
      ...BookmarkShallowFragment
    }
  }
  ${BOOKMARK_SHALLOW_FRAGMENT}
`;
//# sourceMappingURL=bookmark.js.map